module.exports = __webpack_public_path__ + "static/media/logo-external.0104267b.png";